module.exports = __webpack_public_path__ + "static/ncdhhs-c679b7120bdb33ea1a4ace647728895a.png";